module.exports = __webpack_public_path__ + "img/5-121204193951.ce66c43f.gif";